import React from 'react';
import Toolbar from 'components/common/Toolbar';
import ToolbarGroup from 'components/common/Toolbar/Group';
import {Input, Button} from 'antd';
import MaterialIcon from 'components/common/MaterialIcon';
import PropTypes from 'prop-types';
import v1uuid from 'uuid/v1';
import P2 from './PrimitiveCharts2';
import P3 from './PrimitiveCharts3';

@autobind
/**
 *
 */
export default class PrimitiveCharts extends React.PureComponent {
  static propTypes = {
    reference: PropTypes.func,
  };


  /**
   *
   * @return {XML}
   */
  render() {
    const {reference, ...rest} = this.props;
    let state = Object.assign({}, {
      backgroundColor: {hex: '#404040'},
      organizationChart: 'chart',
    }, app.local.load('app'));
    if (state.organizationChart === 'tree') {
      return (<P2
        ref={(input) => {
          this._list = input;
          reference && reference(input);
        }}
        {...rest} />);
    } else {
      return (<P3
        ref={(input) => {
          this._list = input;
          reference && reference(input);
        }}
        {...rest} />);
    }
  }
}
